package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.EvenOdd
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

val Svg.VideoAlpha: ImageVector
    get() {
        if (_videoAlpha != null) {
            return _videoAlpha!!
        }
        _videoAlpha = Builder(
            name = "VideoAlpha", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp,
            viewportWidth = 24.0f, viewportHeight = 24.0f
        ).apply {
            group {
                path(
                    fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = EvenOdd
                ) {
                    moveTo(20.84f, 2.18f)
                    lineTo(16.91f, 2.96f)
                    lineTo(19.65f, 6.5f)
                    lineTo(21.62f, 6.1f)
                    lineTo(20.84f, 2.18f)
                    lineTo(20.84f, 2.18f)
                    close()
                    moveTo(13.97f, 3.54f)
                    lineTo(12.0f, 3.93f)
                    lineTo(14.75f, 7.46f)
                    lineTo(16.71f, 7.07f)
                    lineTo(13.97f, 3.54f)
                    lineTo(13.97f, 3.54f)
                    close()
                    moveTo(9.07f, 4.5f)
                    lineTo(7.1f, 4.91f)
                    lineTo(9.85f, 8.44f)
                    lineTo(11.81f, 8.05f)
                    lineTo(9.07f, 4.5f)
                    lineTo(9.07f, 4.5f)
                    close()
                    moveTo(4.16f, 5.5f)
                    lineTo(3.18f, 5.69f)
                    curveTo(2.098f, 5.906f, 1.396f, 6.958f, 1.61f, 8.04f)
                    lineTo(2.0f, 10.0f)
                    lineTo(6.9f, 9.03f)
                    lineTo(4.16f, 5.5f)
                    lineTo(4.16f, 5.5f)
                    close()
                    moveTo(2.0f, 10.0f)
                    lineTo(2.0f, 20.0f)
                    curveTo(2.0f, 21.11f, 2.9f, 22.0f, 4.0f, 22.0f)
                    lineTo(20.0f, 22.0f)
                    curveTo(21.11f, 22.0f, 22.0f, 21.11f, 22.0f, 20.0f)
                    lineTo(22.0f, 10.0f)
                    lineTo(2.0f, 10.0f)
                    lineTo(2.0f, 10.0f)
                    lineTo(2.0f, 10.0f)
                    close()
                    moveTo(14.025f, 17.017f)
                    lineTo(14.025f, 15.897f)
                    lineTo(14.926f, 15.897f)
                    curveTo(15.06f, 16.295f, 15.144f, 16.675f, 15.144f, 17.017f)
                    lineTo(14.025f, 17.017f)
                    lineTo(14.025f, 17.017f)
                    close()
                    moveTo(13.789f, 13.659f)
                    curveTo(13.532f, 13.261f, 13.269f, 12.881f, 13.017f, 12.539f)
                    lineTo(12.905f, 12.539f)
                    lineTo(12.905f, 13.659f)
                    lineTo(13.789f, 13.659f)
                    lineTo(13.789f, 13.659f)
                    close()
                    moveTo(14.025f, 15.897f)
                    lineTo(14.025f, 14.778f)
                    lineTo(12.905f, 14.778f)
                    lineTo(12.905f, 15.897f)
                    lineTo(14.025f, 15.897f)
                    lineTo(14.025f, 15.897f)
                    close()
                    moveTo(14.025f, 14.039f)
                    lineTo(14.025f, 14.778f)
                    lineTo(14.439f, 14.778f)
                    curveTo(14.304f, 14.532f, 14.17f, 14.28f, 14.025f, 14.039f)
                    lineTo(14.025f, 14.039f)
                    close()
                    moveTo(11.786f, 18.136f)
                    lineTo(11.786f, 17.017f)
                    lineTo(12.905f, 17.017f)
                    lineTo(12.905f, 15.897f)
                    lineTo(11.786f, 15.897f)
                    lineTo(11.786f, 14.778f)
                    lineTo(12.905f, 14.778f)
                    lineTo(12.905f, 13.659f)
                    lineTo(11.786f, 13.659f)
                    lineTo(11.786f, 12.539f)
                    lineTo(12.905f, 12.539f)
                    lineTo(12.905f, 12.388f)
                    curveTo(12.289f, 11.565f, 11.786f, 11.0f, 11.786f, 11.0f)
                    curveTo(11.786f, 11.0f, 8.428f, 14.778f, 8.428f, 17.017f)
                    curveTo(8.428f, 18.869f, 9.933f, 20.375f, 11.786f, 20.375f)
                    lineTo(11.786f, 19.256f)
                    lineTo(12.905f, 19.256f)
                    lineTo(12.905f, 18.136f)
                    lineTo(11.786f, 18.136f)
                    lineTo(11.786f, 18.136f)
                    close()
                    moveTo(12.905f, 20.179f)
                    curveTo(13.325f, 20.034f, 13.7f, 19.815f, 14.025f, 19.513f)
                    lineTo(14.025f, 19.256f)
                    lineTo(12.905f, 19.256f)
                    lineTo(12.905f, 20.179f)
                    lineTo(12.905f, 20.179f)
                    close()
                    moveTo(12.905f, 18.136f)
                    lineTo(14.025f, 18.136f)
                    lineTo(14.025f, 17.017f)
                    lineTo(12.905f, 17.017f)
                    lineTo(12.905f, 18.136f)
                    lineTo(12.905f, 18.136f)
                    close()
                    moveTo(14.025f, 19.256f)
                    lineTo(14.282f, 19.256f)
                    curveTo(14.584f, 18.931f, 14.803f, 18.556f, 14.948f, 18.136f)
                    lineTo(14.025f, 18.136f)
                    lineTo(14.025f, 19.256f)
                    lineTo(14.025f, 19.256f)
                    close()
                }
            }
        }
            .build()
        return _videoAlpha!!
    }

private var _videoAlpha: ImageVector? = null
